import React from "react";
import {Grid} from "@mui/material";
import {PortTheme} from "~/ui/theme";
import {makeStyles} from "@mui/styles";


export type FiltersBarProps = {
    children?: any
}


const useStyles = makeStyles<PortTheme>(theme => ({
    root: {
        overflowY: "auto",
        backgroundColor: theme.palette.background.paper,
        "&::-webkit-scrollbar": {
            display: "none"
        },
        "&::-webkit-scrollbar-thumb": {
            display: "none"
        }
    },
    container: {
        padding: "8px 16px",
        "& .MuiGrid-item:last-child": {
            paddingRight: "16px"
        }
    }
}))


export const FiltersBar = (props: FiltersBarProps) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Grid container spacing={1} wrap="nowrap" direction="row" className={classes.container}>
                {React.Children.map(props.children, (child, key) => (
                    <Grid item key={key}>
                        {child}
                    </Grid>
                ))}
            </Grid>
        </div>
    )
}